import { atom, useSetRecoilState, useRecoilValue, selector } from 'recoil';
import { DebitNote } from '../pages/customer-debit-notes/interface/DebiitNote.Interface';
import { LocationData } from '../pages/sales_order/SalesOrderAddressModal';



// Atoms
export const addressAtom = atom<LocationData>({
  key: 'address_note__note_atom',
  default: { area: [], city: [], country:[] },
});


// Hooks


export const SetAddressStoreAtom = () => useSetRecoilState(addressAtom);
export const GetAddressStoreAtom = () => useRecoilValue(addressAtom);
